/*
         * @ngdoc function
         * @name ePay.Model:Session_Credit_Card_ResponseModel
         * @description
         * Model
         */
import { Session_Captcha } from './Session_CaptchaModel';

export class Session_Credit_Card_ResponseModel {
  fullName: string | null | undefined;
  expiry: string | null | undefined;
  brand: string | null | undefined;
  token: string | null | undefined;
  profile: string | null | undefined;
  cvv: string | null | undefined;
  opaqueData: Session_Captcha | null | undefined;

  constructor(
    fullName?: string,
    brand?: string,
    token?: string,
    expiry?: string,
    opaqueData?: Session_Captcha,
    profile?: string,
    cvv?: string
  ) {
    this.fullName = fullName || null;
    this.brand = brand || null;
    this.token = token || null;
    this.expiry = expiry || null;
    this.opaqueData = opaqueData || new Session_Captcha();
    this.profile = profile || null;
    this.cvv = cvv || null;
  }
}
